import {Component, Input, OnInit} from "@angular/core";
import { Router, UrlSegment, UrlTree } from "@angular/router";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  @Input() items: { link: string; title: string, isHidden?: boolean }[] = [];
  
  filteredItems: { link: string; title: string, isHidden?: boolean }[] =[]
  
  constructor(public router: Router) {}
  
  ngOnInit () {
    this.filteredItems = this.items.filter((itrem) =>  !itrem.isHidden)
  }

  isActive(link: string): boolean {
    let activeRouter = this.router.url.substring(1).split('/')
    return activeRouter[0] === link.substring(1).split('/')[0];
  }
}
